export const summaryRows: string[] = [
  'Volume 1 — Fundamentals of Industrial Chemistry',
  'Volume 2 — Unit Operations & Chemical Process Equipment',
  'Volume 3 — Industrial Chemical Production & Manufacturing Processes',
  'Volume 4 — Process Control, Instrumentation & Industrial Automation',
  'Volume 5 — Industrial Chemical Safety, Quality & Environmental Management',
  'Volume 6 — Chemical Process Optimization, Troubleshooting & Industrial Applications',
  'Bonus 1 — 160 Essential Terms Technical Dictionary',
  'Bonus 2 — 24 Calculation Examples & Formulas Companion',
  'Bonus 3 — 45 Equipment Categories Reference Handbook',
  'Bonus 4 — 12 Industrial Case Studies',
  'Bonus 5 — Safety & Quality Reference Guide + 6 Scenarios',
  '7-day money-back guarantee',
  'Instant access',
];
